import { ASSET_URL } from "../api";
import NO_IMAGE_PLACEHOLDER from "../assets/default_placeholder.png";

export function handleNonValidImg(event) {
  event.target.onerror = null;
  event.target.src = NO_IMAGE_PLACEHOLDER;
}

/**
 * @param {unknown} image
 * @returns {string}
 */
export function extractImageLink(image) {
  if (image == null) return "";
  if (typeof image === "string") return image.trim();
  if (typeof image !== "object") return "";

  const link =
    image.imageLink ??
    image.url ??
    image.assetLink ??
    image.link ??
    "";

  return typeof link === "string" ? link.trim() : "";
}

/**
 * Resolves a stored image path or object to a browser-ready URL.
 * @param {unknown} imageOrLink
 * @returns {string}
 */
export function resolveProductImageSrc(imageOrLink) {
  const imageLink = extractImageLink(imageOrLink);
  if (!imageLink) return "";
  if (/^https?:\/\//i.test(imageLink)) return imageLink;
  if (!ASSET_URL) return imageLink;
  return `${ASSET_URL}/${imageLink.replace(/^\//, "")}`;
}

/**
 * Extracts the best available image path from a product (no URL prefix).
 * @param {Object|null|undefined} product
 * @returns {string}
 */
export function getDefaultImageUrl(product) {
  if (!product || typeof product !== "object") return "";

  const fromPrimary = extractImageLink(product.primaryImageUrl);
  if (fromPrimary) return fromPrimary;

  const fromDefault = extractImageLink(product.defaultImage);
  if (fromDefault) return fromDefault;

  if (Array.isArray(product.images) && product.images.length > 0) {
    const markedDefault = product.images.find((img) => img?.isDefault);
    const fromMarkedDefault = extractImageLink(markedDefault);
    if (fromMarkedDefault) return fromMarkedDefault;
    return extractImageLink(product.images[0]);
  }

  return "";
}

/**
 * @param {Object|null|undefined} product
 * @returns {string}
 */
export function getProductImageSrc(product) {
  return resolveProductImageSrc(getDefaultImageUrl(product)) || NO_IMAGE_PLACEHOLDER;
}
